// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { initSentry } from './observability'
import App from './App'
import './index.css'

initSentry();

function Fallback() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#0f0f0f', color: '#fff',
      fontFamily: 'system-ui', textAlign: 'center', padding: '2rem'
    }}>
      <div>
        <h1 style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>
          Something went wrong
        </h1>
        <p style={{ color: '#a0a0a0', marginBottom: '1.5rem' }}>
          The error has been reported. Try reloading the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '0.5rem 1rem', borderRadius: '0.5rem',
            border: '1px solid #2a2a2a', background: '#1a1a1a',
            color: '#fff', cursor: 'pointer'
          }}
        >
          Reload
        </button>
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <Sentry.ErrorBoundary fallback={<Fallback />}>
    <App />
  </Sentry.ErrorBoundary>
)
